import React, { useState } from 'react';
import { getAllVenueDashboardData } from '../../data/venueDashboardData';
import './VenueDashboardDemo.css';

const VenueDashboardDemo = () => {
  const [selectedVenue, setSelectedVenue] = useState('dugisharma2013@gmail.com');
  const allVenueData = getAllVenueDashboardData();

  const venueOptions = Object.keys(allVenueData).map(venueId => ({
    id: venueId,
    name: allVenueData[venueId].venueName,
    email: venueId.includes('@') ? venueId : null
  }));

  const selectedData = allVenueData[selectedVenue];

  return (
    <div className="venue-dashboard-demo">
      <div className="demo-header">
        <h1>Venue Dashboard Demo</h1>
        <p>Select a venue to view their dashboard data</p>
        
        <div className="venue-selector">
          <label htmlFor="venue-select">Choose Venue:</label>
          <select 
            id="venue-select"
            value={selectedVenue} 
            onChange={(e) => setSelectedVenue(e.target.value)}
            className="venue-select"
          >
            {venueOptions.map(venue => (
              <option key={venue.id} value={venue.id}>
                {venue.name} {venue.email && `(${venue.email})`}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="demo-content">
        <div className="demo-section">
          <h3>Dashboard Data Preview</h3>
          <div className="data-preview">
            <div className="preview-card">
              <h4>Venue Info</h4>
              <p><strong>Name:</strong> {selectedData.venueName}</p>
              <p><strong>Email:</strong> {selectedVenue.includes('@') ? selectedVenue : 'N/A'}</p>
            </div>

            <div className="preview-card">
              <h4>Today's Bookings</h4>
              <div className="booking-counts">
                <span className="count-item">Total: {selectedData.bookings.all}</span>
                <span className="count-item open">Open: {selectedData.bookings.open}</span>
                <span className="count-item accepted">Accepted: {selectedData.bookings.accepted}</span>
                <span className="count-item completed">Completed: {selectedData.bookings.completed}</span>
                <span className="count-item cancelled">Cancelled: {selectedData.bookings.cancelled}</span>
              </div>
            </div>

            <div className="preview-card">
              <h4>Performance Metrics</h4>
              <p><strong>Bookings Completed:</strong> {selectedData.performance.bookingsCompleted.current} 
                <span className="positive-change"> (+{selectedData.performance.bookingsCompleted.change}%)</span>
              </p>
              <p><strong>Total Revenue:</strong> £{selectedData.performance.totalRevenue.current.toLocaleString()}
                <span className="positive-change"> (+{selectedData.performance.totalRevenue.change}%)</span>
              </p>
            </div>

            <div className="preview-card">
              <h4>Staff Availability</h4>
              <div className="staff-info">
                <div className="staff-item">
                  <span>Front of House:</span> {selectedData.staffAvailability.frontOfHouse.current}/{selectedData.staffAvailability.frontOfHouse.total}
                </div>
                <div className="staff-item">
                  <span>Kitchen:</span> {selectedData.staffAvailability.kitchen.current}/{selectedData.staffAvailability.kitchen.total}
                </div>
                <div className="staff-item">
                  <span>Floor Staff:</span> {selectedData.staffAvailability.floorStaff.current}/{selectedData.staffAvailability.floorStaff.total}
                </div>
              </div>
            </div>

            <div className="preview-card">
              <h4>Tasks ({selectedData.tasks.length} items)</h4>
              <div className="tasks-list">
                {selectedData.tasks.slice(0, 3).map(task => (
                  <div key={task.id} className="task-item">
                    <span className="task-ref">{task.bookingRef}</span>
                    <span className="task-title">{task.title}</span>
                    <span className="task-assignee">- {task.assignee}</span>
                  </div>
                ))}
                {selectedData.tasks.length > 3 && (
                  <div className="task-item more">
                    +{selectedData.tasks.length - 3} more tasks
                  </div>
                )}
              </div>
            </div>

            <div className="preview-card">
              <h4>Today's Schedule</h4>
              <div className="schedule-list">
                {selectedData.todaysBookings.map(booking => (
                  <div key={booking.id} className="schedule-item">
                    <span className="schedule-time">{booking.time}</span>
                    <span className="schedule-title">{booking.title}</span>
                    <span className={`schedule-status ${booking.status}`}>{booking.status}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="demo-section">
          <h3>Raw Data (JSON)</h3>
          <pre className="json-preview">
            {JSON.stringify(selectedData, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default VenueDashboardDemo;

